import Api from '@/api/Api'

class BatchApi extends Api {
  protected resource = 'batches'

  public async generateCode<T>(batchId: number, option = {}): Promise<T> {
    const { data, error, response } = await this.fetch(`${this.resource}/${batchId}/generate-code`)
      .post(option)
      .json()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }

  public async sendToPrinter<T>(batchId: number, option = {}): Promise<T> {
    const { data, error, response } = await this.fetch(
      `${this.resource}/${batchId}/send-to-printer`
    )
      .post(option)
      .json()

    return this.handleResponse<T>(data.value, error.value, response.value?.status)
  }
}

export default new BatchApi()
